import { type CreateIntegrationOnboardingSessionResponse } from '@heidi/integrations/connected-apps/contracts';
import { type GetIntegrationsScheduleType } from '@heidi/integrations/ehr/contracts';

export interface GetScheduleMixin {
  getSchedule(data: {
    startDate: string;
    endDate: string;
    integrationOnboardingSession: CreateIntegrationOnboardingSessionResponse;
  }): Promise<GetIntegrationsScheduleType>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const hasGetScheduleMixin = (mixin: any): mixin is GetScheduleMixin => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return !!mixin && 'getSchedule' in mixin && typeof mixin.getSchedule === 'function';
};
